export enum TypeNotification {
  success = 'success',
  info = 'info',
  error = 'error',
  warning = 'warning'
}

